/* Visible product and photographic motion. Offer, drawer, and disclosure motion
   remains in the separate v5 module. Nothing here delays a purchase action. */
(() => {
  'use strict';
  // The reader PDP pilot has no bottle entrance, scroll entrances or photo parallax (ap-reader-pdp.css keeps one short fade).
  if (document.body.classList.contains('ap-reader-pdp')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const still = () => reduce.matches || document.body.classList.contains('paused');
  const ease = 'cubic-bezier(.16,1,.3,1)';
  const running = new Set();
  function play(element, frames, duration, delay = 0) {
    if (!element || still()) return;
    const animation = element.animate(frames, {duration, delay, easing:ease, fill:'backwards'});
    running.add(animation);
    const clear = () => running.delete(animation);
    animation.finished.then(clear, clear);
    return animation;
  }

  // The bottle stays in its original image, with space around it during the entrance.
  const heroBottle = document.querySelector('.main-product-image>img');
  const enterHero = () => {
    if (heroBottle.closest('[hidden]') || heroBottle.getBoundingClientRect().bottom < 0) return;
    play(heroBottle, [
      {opacity:0, transform:'translateY(30px) rotate(-3deg) scale(.95)'},
      {opacity:1, transform:'translateY(0) rotate(0deg) scale(1)'}
    ], 1100, 80);
  };
  if (heroBottle.complete) enterHero();
  else heroBottle.addEventListener('load', enterHero, {once:true});

  const entrances = new IntersectionObserver(entries => {
    const batch = entries.filter(entry => entry.isIntersecting);
    batch.forEach((entry, index) => {
      entrances.unobserve(entry.target);
      if (still()) return;
      const element = entry.target;
      // Only stagger items that actually arrive together, including horizontal mobile cards.
      const delay = Math.min(index, 2) * 100;
      if (element.matches('.benefit-detail')) {
        play(element.querySelector('.benefit-detail-image'), [
          {opacity:.2, clipPath:'inset(10% 0 0 0 round 14px)', transform:'translateY(22px)'},
          {opacity:1, clipPath:'inset(0% 0 0 0 round 14px)', transform:'translateY(0)'}
        ], 900, delay);
        play(element.querySelector('.benefit-detail-copy'), [
          {opacity:0, transform:'translateY(18px)'},
          {opacity:1, transform:'translateY(0)'}
        ], 750, delay + 140);
      } else {
        play(element, [
          {opacity:0, transform:'translateY(30px)'},
          {opacity:1, transform:'translateY(0)'}
        ], 850, delay);
        play(element.querySelector('.related-image>img'), [
          {transform:'translateY(16px) rotate(-3deg) scale(.96)'},
          {transform:'translateY(0) rotate(0deg) scale(1)'}
        ], 1100, delay + 70);
      }
    });
  }, {threshold:.16});
  document.querySelectorAll('.benefit-detail,.related-card').forEach(element => entrances.observe(element));

  // Scroll-linked depth is bounded and only measured while a photograph is nearby.
  // No perpetual frame loop: scrolling, resizing, and intersections request one frame.
  const photos = [...document.querySelectorAll('.benefit-detail-image,.proof-flag')];
  const visiblePhotos = new Set();
  let frame = 0;
  function positionPhotos() {
    frame = 0;
    if (still()) return;
    visiblePhotos.forEach(element => {
      const rect = element.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / ((innerHeight + rect.height) / 2)));
      const distance = element.matches('.proof-flag') ? 26 : 13;
      element.style.setProperty('--photo-offset', `${(progress * distance).toFixed(2)}px`);
    });
  }
  function schedulePhotos() {
    if (!frame && !still() && visiblePhotos.size) frame = requestAnimationFrame(positionPhotos);
  }
  const photoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? visiblePhotos.add(entry.target) : visiblePhotos.delete(entry.target));
    schedulePhotos();
  }, {rootMargin:'60px 0px'});
  photos.forEach(element => photoObserver.observe(element));
  addEventListener('scroll', schedulePhotos, {passive:true});
  addEventListener('resize', schedulePhotos, {passive:true});
  function syncMotion() {
    if (still()) {
      running.forEach(animation => animation.cancel());
      running.clear();
      cancelAnimationFrame(frame);
      frame = 0;
      photos.forEach(element => element.style.removeProperty('--photo-offset'));
    } else schedulePhotos();
  }
  new MutationObserver(syncMotion).observe(document.body, {attributes:true, attributeFilter:['class']});
  reduce.addEventListener('change', syncMotion);
  syncMotion();
})();
